const actions = {
  async getVendorsForPlatform(context, platformId) {
    return await context.getters.CxmApiClient.ProcessRequest("GET", `/api/dealer_settings/vendor/${platformId}`).catch(err => err.response);
  },
  async saveVendorsForPlatform(context, requestPackage) {
    return await context.getters.CxmApiClient.ProcessRequest("POST", `/api/dealer_settings/vendor/${requestPackage.platformId}`, requestPackage).catch(err => err.response);
  },
  async getIntegrationUsers(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "api/integration/v2/employees/lookup",
      request).catch(err => err.response);
    return response && response.data ? response.data : null;
  },
  async getUserIntegrations(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "api/integration/v1/user/employee/batch",
      request).catch(err => err.response);
    return response && response.data ? response.data : null;
  },
  async saveUserIntegrations(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "put",
      "api/integration/v1/user/employee/batch",
      request).catch(err => err.response);
    return response && response.data ? response.data : null;
  },
  async syncFourEyes(context, platformId) {
    return await context.getters.CxmApiClient.ProcessRequest("POST", `/api/foureyes/syncconsents?accountPlatformId=${platformId}`).catch(err => err.response);
  }
}

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/Integrations.js